
export const STRIPE_SUCCESS_PARAM   = "stripesucc"; // In fact it doesn't
export const STRIPE_FAILURE_PARAM   = "stripefail"; // Could have made it stripesucks but...
export const STRIPE_PAYMENT_METHOD_SUCCESS_PARAM = "stripepm";


